type AppErrorType = 'api' | 'app' | 'auth' | 'limit';

const APP_ERROR_CODE = 1001;

export default class AppError extends Error {
  code: number;
  type: AppErrorType;
  override message: string;
  errorCodes?: string[];
  errorMessages?: string[];

  constructor(type: AppErrorType, code: number | null, message: string, errorCodes?: string[], errorMessages?: string[]) {
    super(message);

    this.code = code || APP_ERROR_CODE;
    this.type = type;
    this.message = message;
    this.errorCodes = errorCodes;
    this.errorMessages = errorMessages;
  }
}
